import { SocketContext } from "context/socketContext";
import { useCallback, useContext, useEffect, useState } from "react";
import { useRequest } from "ahooks";
import { AdminContext } from "context/adminContext";
import { NotificationContext } from "context/notificationContext";
import {
  endSupportChat,
  initiateSupportRequest,
  // getPossibleChangeSupports,
  // postChangeSupport,
  readChatByAdmin,
  startSupportChat,
} from "helpers/backend_helper";

import { Chat } from "pages/Main/Components/Chat";
// import { Button, Popconfirm } from "antd";
import styles from "./index.module.css";
// import { ChatsContext } from "context/chatsContext";
import { STATUSES } from "..";
import { NoChatComponent } from "Components/NoChatComponent";
import { useNavigate } from "react-router";
import { RevealChatComponent } from "Components/RevealChatComponent";

type Props = {
  id: string;
  currentStatusChat: STATUSES;
  closeChat: () => void;
  userId: string;
  unreadMessages: number;
  switchChat: (key: string) => void;
};

const AdminChat = ({ id, currentStatusChat, userId, unreadMessages, switchChat }: Props) => {
  const { sendMessageSupport } = useContext(SocketContext);
  const {
    localCountry,
    getChatHistory,
    getHistoryLoading,
    chats,
    hasMore,
    // accountData,
    sessionHistoryIsUsed,
    setChats,
    chatMetaRef,
  } = useContext(AdminContext);
  const { openNotificationWithIcon } = useContext(NotificationContext);
  // const [supports, setSupports] = useState();
  // const { refreshUsersByStatus, paginationChats } = useContext(ChatsContext);
  const navigate = useNavigate();
  const { loading: loadingSessionStart, runAsync: startSession } = useRequest(
    () => startSupportChat(localCountry?.iso, id),
    {
      ready: !!id,
      manual: true,
      onError: (error: any) => {
        openNotificationWithIcon("error", error.response?.data?.message || "something went wrong");
      },
      onSuccess: () => {
        setTimeout(() => {
          switchChat("1");
        });
        openNotificationWithIcon("success", "The session has started");
      },
    },
  );

  const { loading: loadingSessionInitiate, runAsync: initiateRequest } = useRequest(
    () => initiateSupportRequest(userId),
    {
      ready: !!id,
      manual: true,
      onError: (error: any) => {
        openNotificationWithIcon("error", error.response?.data?.message || "something went wrong");
      },
      onSuccess: () => {
        setTimeout(() => {
          switchChat("1");
        });
        openNotificationWithIcon("success", "The session has started");
      },
    },
  );
  const { loading: loadingSessionEnd, runAsync: endSession } = useRequest(() => endSupportChat(localCountry?.iso, id), {
    ready: !!id,
    manual: true,
    onError: (error: any) => {
      openNotificationWithIcon("error", error.response?.data?.message || "something went wrong");
    },
    onSuccess: () => {
      setTimeout(() => {
        switchChat("2");
      });
      openNotificationWithIcon("success", "The request has resolved");
    },
  });

  const getChatHistoryCallback = useCallback(() => {
    getChatHistory({ chatId: id, cursor: 0, localCountry: localCountry?.iso });
  }, [getChatHistory, id, localCountry?.iso]);

  useEffect(() => {
    if (id) {
      getChatHistoryCallback();
    }
  }, [id]);

  const goToUser = () => {
    // navigate(
    //   {
    //     search: `?countryUserId=${data?.user.countryUserId}&mainId=${data?.user.mainUserId}`,
    //     pathname: "/users/user",
    //   },
    //   { replace: true },
    // );
    setChats({ debateChat: { cursor: 0, messages: [] }, selected: null, supportChat: { cursor: 0, messages: [] } });
    navigate(`/users/user?countryUserId=${userId}&isRenter=true`, { replace: false });
  };

  // useRequest(() => getPossibleChangeSupports(id, localCountry.iso), {
  //   refreshDeps: [id, paginationChats, currentStatusChat],
  //   ready: !!id,
  //   onError: (error: any) => {
  //     openNotificationWithIcon("error", error.response?.data?.message || "something went wrong");
  //   },
  //   onSuccess: (data) => {
  //     if (data.length) {
  //       const supportList = data
  //         .filter((sup) => sup.id !== accountData.id)
  //         .map((sup) => {
  //           return {
  //             key: sup.id,
  //             label: (
  //               <Popconfirm
  //                 key={sup.id}
  //                 title="Transfer chat?"
  //                 onConfirm={() => {
  //                   postChangeSupport(id, sup.id, localCountry.iso).then(() => {
  //                     closeChat();
  //                     paginationChats.current.skip = 0;
  //                     refreshUsersByStatus();
  //                     openNotificationWithIcon("success", "User successfully transfered to another support");
  //                   });
  //                 }}
  //               >
  //                 <Button type="primary" ghost style={{ color: "#000" }}>
  //                   <div>
  //                     <span>{sup.firstName} </span>
  //                     <span>{sup.lastName}</span>
  //                   </div>
  //                 </Button>
  //               </Popconfirm>
  //             ),
  //           };
  //         });
  //       setSupports(supportList);
  //     }
  //   },
  // });

  const [isRevealed, setIsRevealed] = useState(false);
  useEffect(() => {
    setIsRevealed(!unreadMessages);
  }, [unreadMessages]);

  const { runAsync: readChat } = useRequest(
    (messageId: number) => {
      return readChatByAdmin(id, messageId, localCountry?.iso);
    },
    {
      ready: !!id,
      refreshDeps: [localCountry?.iso, id],
      manual: true,
      onError: (error: any) => {
        openNotificationWithIcon("error", error.response?.data?.message || "something went wrong");
      },
    },
  );

  return (
    <>
      {id ? (
        <div style={{ width: "100%", height: "100%", position: "relative" }}>
          {!isRevealed ? (
            <RevealChatComponent
              unreadMessages={unreadMessages}
              onReveal={() => {
                setIsRevealed(true);
                if (chatMetaRef?.current?.firstUnreadMessageId) {
                  const emptyArrayOfIds = new Array(
                    chatMetaRef.current.lastUnreadMessageId - chatMetaRef.current.firstUnreadMessageId + 1,
                  ).fill(0);
                  const arrayOfIds = emptyArrayOfIds.map((_, i) => chatMetaRef.current.firstUnreadMessageId + i);
                  arrayOfIds.forEach((v) => readChat(v));
                }
              }}
            />
          ) : null}
          <div
            className={styles.chatContainer}
            style={isRevealed ? { filter: "none", backgroundColor: "transparent" } : null}
          >
            <Chat
              ids={{ cursor: chats.supportChat.cursor, chatId: id, userId }}
              flags={{
                hasMore: hasMore.current,
                loading: getHistoryLoading,
                isOnUser: false,
                onActionLoading: loadingSessionEnd || loadingSessionStart || loadingSessionInitiate,
                currentStatus: currentStatusChat,
              }}
              handlers={{
                loadMore: (cursor) => getChatHistory({ cursor, chatId: id, localCountry: localCountry?.iso }),
                sendSocketMessage: sendMessageSupport,
                goToUser,
                switchChat: switchChat,
                onStart: async (isRequest) => {
                  if (isRequest) {
                    await startSession();
                  } else {
                    await initiateRequest();
                  }
                },
                onFinish: async () => {
                  await endSession();
                },
                onSelectedSession: (sessionId) => {
                  sessionHistoryIsUsed.current = true;
                  getChatHistory({ chatId: id, sessionId, localCountry: localCountry?.iso });
                },
                onTakeRequest: async (isRequest: boolean) => {
                  if (isRequest) {
                    await startSession();
                  } else {
                    await initiateRequest();
                  }
                },
              }}
              data={{
                chatData: chats?.supportChat,
                action:
                  currentStatusChat === STATUSES.WAIT
                    ? "Take"
                    : currentStatusChat === STATUSES.IN_PROGRESS
                    ? "Complete"
                    : "",
              }}
            />
          </div>
        </div>
      ) : (
        <NoChatComponent />
      )}
    </>
  );
};

export default AdminChat;
